/**
 * NOS-266 builder UI kit: the 10px uppercase micro-label plus the shared
 * panel input/textarea styles. fontFamily is omitted on purpose — panel
 * subtrees inherit it from FloatingPanel / `.builder-root`, and Tailwind
 * preflight makes form controls inherit the surrounding font.
 */
import type { CSSProperties, LabelHTMLAttributes } from "react"

export const GROUP_LABEL: CSSProperties = {
  fontSize: 10,
  fontWeight: 600,
  textTransform: "uppercase",
  color: "rgba(255,255,255,0.35)",
  marginBottom: 6,
  display: "block",
}

export const PANEL_INPUT: CSSProperties = {
  width: "100%",
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: 8,
  padding: "7px 10px",
  color: "#fff",
  fontSize: 12,
  outline: "none",
  boxSizing: "border-box",
}

export const PANEL_TEXTAREA: CSSProperties = {
  ...PANEL_INPUT,
  resize: "vertical",
  minHeight: 60,
}

export function GroupLabel({
  style,
  children,
  ...props
}: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label style={{ ...GROUP_LABEL, ...style }} {...props}>
      {children}
    </label>
  )
}
